import React ,{useEffect,useState} from "react";
import "./Location.scss"; // Import a separate CSS file for styling
import imgLocation from "../../assets/fondoLocation.jpg";
import {fetchWithCache} from "../services/FirebaseData"
import { Helmet } from "react-helmet-async";

const baseData = {
  "location" : {
      "ubi": "9610 Stirling Rd, Unit 104, in Cooper City, FL",
      "openHours":[
      ["Monday","9:00 AM - 6:00 PM"],
      ["Tuesday","9:00 AM - 6:00 PM"],
      ["Wednesday","9:00 AM - 6:00 PM"],
      ["Thursday","9:00 AM - 6:00 PM"],
      ["Friday","9:00 AM - 6:00 PM"],
      ["Saturday","9:00 AM - 6:00 PM"],
      ["Sunday","Closed"]
      ],
      "googlelink":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d896.1735463695385!2d-80.27364387296474!3d26.043560328925548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9072625f365d1%3A0x42932fea2d3c9e2!2sAlterations%20By%20Sdenka%20And%20Paola!5e0!3m2!1ses!2sus!4v1736784712490!5m2!1ses!2sus",
      "googletitle" :"Studio at Cooper City, FLorida"
    },
}
                
function Location() {
  const [content, setContent] = useState(baseData);
  
    useEffect(() => {
      fetchWithCache( "firebaseContent")
        .then((data) => setContent(data))
        .catch((error) => console.error("Error fetching content:", error));
    }, []);

 

  return (
    <div className="location-container">
      <Helmet>
        <title>Find Us | Alterations By Sdenka And Paola | Cooper City, FL</title>
        <meta name="description" content="Visit Alterations By Sdenka And Paola in Cooper City, Florida. Get expert alterations and tailoring services near you. Click here for directions and store hours." />
        <link rel="canonical" href="https://www.alterationsbysdenka-paola.com/location" />
      </Helmet>
      <div className="location-content">
        <div className="info-box"
         aria-labelledby="location-info-heading"
         aria-describedby="location-info-details"
         >
          <center><h1>Custom Clothing and Alteration Experts</h1></center>
          <p>
          Whether you need standard services, intricate bridal alterations, specialty adjustments, or custom clothing, our talented team has you covered. Visit us at {content.location.ubi}, for expert care and perfect results.
          </p>


          <div className="container_locationTI">
            {content.location.openHours && 
              <div className="table-container">
              <h3>Open Hours<br />
              </h3>
              <table>
                <tbody>
                  {content.location.openHours.map(([day, time], index) => (
                    <tr key={index}>
                      <td style={{ padding: "5px" }}>{day}</td>
                      <td style={{ padding: "5px" }}>{time}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>}
            <div className="image-container-location">
              <img
                src={imgLocation} // Replace with your image URL
                alt="Entrance of our studio at Cooper City, Florida
                "
              />
            </div>
          </div>
        </div>
        <div
              className="map-box"
              aria-label="Interactive map of our location in Cooper City, Florida"
            >
          <iframe title={content.location.googletitle}  src={content.location.googlelink}  style={{width:"100%", height:"100%"}} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  );
}

export default Location;